import type {CodeNavigationInfo, CodeSymbol} from '@github-ui/code-nav'
import {ScopedCommands} from '@github-ui/ui-commands'

import {useCodeNav} from '../../../../hooks/use-code-nav'
import {useTaillightsBlobEnabled} from '../../../taillights/BlobSearchProvider'
import {TaillightsCodeNavSymbolDetails} from '../../../taillights/TaillightsCodeNavSymbolDetails'
import {CodeNavSymbolDetailsHeader, CodeNavSymbolDetailsView} from './CodeNavSymbolDetailsView'

export type CodeNavSymbolDetailsLoaderProps = {
  codeNavInfo: CodeNavigationInfo
  selectedText: string
  lineNumber: number
  offset: number
  onSymbolSelect: (sym: CodeSymbol) => void
  isLoading: boolean
}

export type CodeNavSymbolDetailsProps = CodeNavSymbolDetailsLoaderProps & {
  onClose: () => void
  onBackToSymbol: () => void
}

export function CodeNavSymbolDetails({onClose, onBackToSymbol, ...props}: CodeNavSymbolDetailsProps) {
  const taillights = useTaillightsBlobEnabled()

  return (
    <ScopedCommands commands={{'github:cancel': onClose}}>
      <CodeNavSymbolDetailsHeader onClose={onClose} onBackToSymbol={onBackToSymbol} />
      {taillights ? <TaillightsCodeNavSymbolDetails {...props} /> : <CodeNavSymbolDetailsLoader {...props} />}
    </ScopedCommands>
  )
}

function CodeNavSymbolDetailsLoader(props: CodeNavSymbolDetailsLoaderProps) {
  const results = useCodeNav(props.codeNavInfo, props.selectedText, props.lineNumber, props.offset)

  return (
    <CodeNavSymbolDetailsView
      codeNavInfo={props.codeNavInfo}
      selectedText={props.selectedText}
      onSymbolSelect={props.onSymbolSelect}
      isLoading={props.isLoading}
      results={results}
    />
  )
}
